import React, {Component} from 'react'
import {language} from 'UTIL/common'
export default class SearchInput extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-group clearfix f1">
                <label className="control-name fl">查询条件</label>
                <input type="text" className="form-control" autocomplete="off"
                       id={this.props.id} placeholder={language()[this.props.name]}/>
            </div>
        )
    }
}
//文本框搜索
//<SearchInput id="" name=""/>



// WEBPACK FOOTER //
// ./modules/component/search/searchInput.js